import React from 'react';
import SEO from '../../common/SEO';
import FooterOne from '../../common/footer/FooterOne';
import HeaderTwo from '../../common/header/HeaderTwo';
import BannerOne from '../../components/banner/BannerOne';
import HomeThreeService from '../../components/home-three/HomeThreeService';
import BannerThree from '../../components/banner/BannerThree';
const AboutUs = () => {
    return (
        <>
            <SEO title='Rólunk' />
            <HeaderTwo />
            
            <BannerThree />
            <HomeThreeService />
            <FooterOne />
        </>
    )
}

export default AboutUs;
